import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Text from '../Text';
import SectionHeader from '../SectionHeader';
import ScrollReveal from '../animated/ScrollReveal';
import MagneticButton from '../animated/MagneticButton';
import { colors, gradients } from '../../theme/designTokens';
import { industries } from '../../data/industries';

const IndustriesStrip = () => {
  const navigate = useNavigate();
  const featured = industries.slice(0, 8);

  return (
    <Box
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 8, md: 12 },
        background: colors.white,
        borderTop: `1px solid ${colors.borderLight}`,
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: 'auto' }}>
        <ScrollReveal>
          <SectionHeader
            eyebrow="Industries"
            title="Resilience across sectors."
            highlightWords={['sectors']}
            subtitle="Sector-specific resilience architectures for organizations that cannot afford disruption."
          />
        </ScrollReveal>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' },
            gap: 1.5,
          }}
        >
          {featured.map((ind, i) => (
            <Box
              key={ind.slug}
              component={motion.button}
              type="button"
              onClick={() => navigate(`/industries/${ind.slug}`)}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              whileHover={{ y: -2 }}
              sx={{
                py: 3,
                px: 2,
                textAlign: 'center',
                cursor: 'pointer',
                border: `1px solid ${colors.borderLight}`,
                background: gradients.sectionLight,
                '&:hover': { borderColor: colors.navy },
              }}
            >
              <Text variant="h4" color="primary">
                {ind.title}
              </Text>
            </Box>
          ))}
        </Box>

        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <MagneticButton variant="ghost" onClick={() => navigate('/industries')}>
            View All Industries
          </MagneticButton>
        </Box>
      </Box>
    </Box>
  );
};

export default IndustriesStrip;
